import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../services/auth-store';

export const loginGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(AuthStore);

  if (auth.isAuthenticated()) {
    router.navigate(['/accounts']);
    return false;
  }

  return true;
};
